import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule} from '@angular/material/button';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { MirrorDatePipeModule } from '../../_pipes/mirror-date.pipe';
import { MqIfDirectiveModule } from '../../_directives/mqif.directive';

import { ProductReceiveDialogRoutingModule } from './product-receive-dialog-routing.module';
import { ProductReceiveDialogComponent } from './product-receive-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ProductReceiveDialogRoutingModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatButtonModule,
        // FlexLayoutModule,
        MirrorDatePipeModule,
        MqIfDirectiveModule,
    ],
    declarations: [
        ProductReceiveDialogComponent
    ]
})
export class ProductReceiveDialogModule { }
